export const AD_HOC_PROTOCOL_TITLE = "Ad hoc protocol";
export const VISIT_TITLE = "Visit";
